module.exports = __webpack_public_path__ + "img/clerk_incoming_goods_3.a7c4ba8b.png";